$(document).ready(function() {
    // Open links in new tab
    // In trix content, target="_blank" is not working. So, we are adding target="_blank" using jQuery
    $(".trix-content a").click(function(e) {
        $(this).attr("target","_blank");
    });
})